import { render, staticRenderFns } from "./SendList.vue?vue&type=template&id=50ac414b&"
import script from "./SendList.vue?vue&type=script&lang=js&"
export * from "./SendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports